import { render, staticRenderFns } from "./MbModal.vue?vue&type=template&id=c444736a&"
import script from "./MbModal.vue?vue&type=script&lang=js&"
export * from "./MbModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports